import { render, staticRenderFns } from "./AxSignupWeb.vue?vue&type=template&id=597d9b00&"
import script from "./AxSignupWeb.vue?vue&type=script&lang=ts&"
export * from "./AxSignupWeb.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports